import http from './http';


export default {
	fetchGupshupTemplates(id) {
		return http.get(`/gupshup/templates/` + id);
	}
};
